import React, { useEffect, useState } from "react";
import { Reveal } from "@/components/Reveal";
import api from "@/lib/api";

export default function Gallery() {
  const [items, setItems] = useState([]);
  const [active, setActive] = useState("All");
  useEffect(() => { api.get("/gallery").then(({ data }) => setItems(data)).catch(() => {}); }, []);

  const cats = ["All", ...Array.from(new Set(items.map((i) => i.category).filter(Boolean)))];
  const shown = active === "All" ? items : items.filter((i) => i.category === active);

  return (
    <div className="relative z-10 pt-28">
      <section className="mx-auto max-w-7xl px-5 py-12">
        <Reveal>
          <span className="text-xs uppercase tracking-[0.25em] font-semibold text-primary-c">Gallery</span>
          <h1 className="font-display font-black text-5xl sm:text-6xl tracking-tighter text-t mt-4">A Growing <span className="text-primary-c">Digital Archive.</span></h1>
          <p className="text-muted-c text-lg mt-5 max-w-2xl">Moments from our classrooms, labs, batches and events — old and new. Our story, brought into the digital world.</p>
        </Reveal>

        {cats.length > 1 && (
          <div className="flex flex-wrap gap-2 mt-8">
            {cats.map((c) => (
              <button key={c} onClick={() => setActive(c)}
                className={`px-4 py-2 rounded-full text-sm font-semibold transition-colors ${active === c ? "bg-primary-c text-on-primary" : "btn-ghost"}`}
                data-testid={`gallery-filter-${c}`}>{c}</button>
            ))}
          </div>
        )}

        {shown.length === 0 ? (
          <div className="glass rounded-2xl p-12 text-center text-muted-c mt-10">Photos coming soon.</div>
        ) : (
          <div className="grid gap-4 grid-cols-2 lg:grid-cols-3 mt-10">
            {shown.map((g, i) => (
              <Reveal key={g.id} delay={(i % 3) * 0.06}>
                <figure className="glass card-hover rounded-2xl overflow-hidden" data-testid={`gallery-item-${g.id}`}>
                  <img src={g.imageUrl} alt={g.caption || "Bits & Bytes"} loading="lazy" className="w-full aspect-[4/3] object-cover" />
                  {g.caption && <figcaption className="p-3 text-sm text-t font-medium">{g.caption}</figcaption>}
                </figure>
              </Reveal>
            ))}
          </div>
        )}
      </section>
    </div>
  );
}
